<template>
    <div>
        <v-checkbox
            v-if="isCheckboxProperty"
            :input-value="checkboxValue"
            :label="propertyData.productionProcessProperty.name | capitalize"
            class="ma-0 pa-0"
            hide-details
            :readonly="!isCalculationEditable || isReadOnly"
            :disabled="!isTaskSelected || isDisabled"
            :error="error"
            @change="changeCheckboxValue(propertyData, $event)"
        />

        <v-autocomplete
            v-else-if="propertyData.productionProcessProperty.productionProcessPropertyValues.length > 0"
            :value="property.value"
            :items="propertyData.productionProcessProperty.productionProcessPropertyValues"
            :label="propertyData.productionProcessProperty.name | capitalize"
            :suffix="propertyData.productionProcessProperty.defaultUnit"
            item-value="name"
            item-text="name"
            dense
            outlined
            hide-details
            :clearable="isCalculationEditable && isClearable"
            :readonly="!isCalculationEditable || isReadOnly"
            :disabled="!isTaskSelected || isDisabled"
            :error="error"
            @input="changeValue(propertyData, $event)"
        />

        <v-text-field
            v-else-if="propertyData.productionProcessProperty.mask"
            v-model="property.value"
            v-mask="mask"
            :label="propertyData.productionProcessProperty.name | capitalize"
            :suffix="propertyData.productionProcessProperty.defaultUnit"
            dense
            outlined
            hide-details
            :readonly="!isCalculationEditable || isReadOnly"
            :disabled="!isTaskSelected || isDisabled"
            :error="error"
            @input="changeValue(propertyData, $event)"
        />

        <v-text-field
            v-else
            :value="property.value"
            :label="propertyData.productionProcessProperty.name | capitalize"
            :suffix="propertyData.productionProcessProperty.defaultUnit"
            dense
            outlined
            hide-details
            :readonly="!isCalculationEditable || isReadOnly"
            :disabled="!isTaskSelected || isDisabled"
            :error="error"
            @input="changeValue(propertyData, $event)"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

import { appConfig } from '@/config'
import { addSentryBreadcrumb } from '@/utils/errorHandler'

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
    name: 'TaskProperty',
    props: {
        propertyData: {
            type: Object,
            default: null
        },
        isTaskSelected: {
            type: Boolean
        },
        isCalculationEditable: {
            type: Boolean
        },
        isReadOnly: {
            type: Boolean
        },
        isClearable: {
            type: Boolean
        },
        isDisabled: {
            type: Boolean
        },
        error: {
            type: Boolean
        },
    },
    data() {
        return {
            property: {
                value: this.propertyData.value
            },
        }
    },
    computed: {
        isCheckboxProperty() {
            const propertyType = this.propertyData.productionProcessProperty.propertyType

            return propertyType?.id === appConfig.common.productionProcessPropertyTypes.checkbox
        },
        checkboxValue() {
            return this.property.value === 'true'
        },
        mask() {
            let mask

            if (['decimal', 'integer'].includes(this.propertyData.productionProcessProperty.mask)) {
                mask = createNumberMask({
                    prefix: '',
                    allowDecimal: this.propertyData.productionProcessProperty.dataType === 'decimal',
                    allowNegative: false,
                    includeThousandsSeparator: false
                })
            } else {
                mask = this.propertyData.productionProcessProperty.mask
            }

            return mask
        }
    },
    watch: {
        propertyData: {
            handler(newValue) {
                this.property = newValue
            },
            deep: true
        }
    },
    methods: {
        changeCheckboxValue(property, value) {
            this.changeValue(property, value ? 'true' : 'false')
        },
        changeValue(property, value) {
            addSentryBreadcrumb('ui.action', `Zmiana parametru "${property.productionProcessProperty.name}" na wartość "${value}"`)
            this.property.value = value
            this.$emit('input', value)
        }
    }
}
</script>
